var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetDisposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9.3 21.449l-4.594 4.593L9.3 30.636",
    id: "Vrstva_1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.684 33.735l5.577 2.602 14.559-6.526v-17.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M39.82 12.511L25.094 6.988 10.2 13.118v2.864"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.2 13.118l15.145 5.459 14.475-6.066M25.324 19.058v15.553M30.031 22.196l5.187-2.217"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.031,
    cy: 27.154,
    r: 1.444
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.244 26.007H7.028"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDisposal);
export default __webpack_public_path__ + "static/media/assetDisposal.d9eb33ea1e5301865584e3af57085980.svg";
export { ForwardRef as ReactComponent };